<template>
  <div class="col-md-12 report-wrapper">
    <barra-navegacao :visiblebutton="true"/>
    
    <!-- <div class="d-flex align-items-center mt-3 mb-4">
      <div class="page-icon-wrapper mr-3">
        <b-icon icon="file-earmark-bar-graph" font-scale="1.8" style="color: #303f9f;"></b-icon>
      </div>
      <div>
        <h3 class="mb-0 page-title">Central de Relatórios</h3>
        <p class="text-muted mb-0 page-subtitle">Exporte dados e métricas do sistema</p>
      </div>
    </div> -->

    <b-card no-body class="modern-card">
      <b-card-body class="p-4">
        <h5 class="section-title mb-4 text-center w-100">Relatórios</h5>
        <b-row>
          <b-col md="6" class="border-right-custom pr-md-4">
            
            <b-form-group label="Tipo de Relatório" label-class="font-weight-bold">
              <model-list-select :list="tiposRelatorio"
                                 v-model="tipoSelecionado"
                                 option-value="value"
                                 option-text="text"
                                 placeholder="Selecione o Tipo de Relatório...">
              </model-list-select>
            </b-form-group>

            <transition name="fade">
              <div v-if="['CHECKLIST_PERIODO', 'TOP_DEFEITOS', 'PROGRESSO'].includes(tipoSelecionado)" class="mt-3">
                <b-form-group label="Parâmetro" label-class="font-weight-bold">
                  <b-form-select v-model="parametros.modulo" :options="opcoesModulo" class="custom-input" />
                </b-form-group>
              </div>
            </transition>

            <transition name="fade">
              <div v-if="tipoSelecionado === 'OCORRENCIAS'" class="mt-3">
                <b-form-group label="Filtrar Ocorrências por" label-class="font-weight-bold">
                  <b-form-select v-model="filtroOcorrencia" :options="opcoesFiltroOcorrencia" class="custom-input" />
                </b-form-group>
              </div>
            </transition>

            <transition name="fade">
              <div v-if="tipoSelecionado === 'OCORRENCIAS' && filtroOcorrencia === 'BLOCO'" class="mt-3">
                <b-form-group label="Selecione o Bloco" label-class="font-weight-bold">
                  <b-form-select v-model="parametros.idBloco" :options="opcoesBloco" class="custom-input" />
                </b-form-group>
              </div>
            </transition>

            <transition name="fade">
              <div v-if="tipoSelecionado === 'OCORRENCIAS' && filtroOcorrencia === 'CORREDOR'" class="mt-3">
                <b-form-group label="Selecione o Corredor" label-class="font-weight-bold">
                  <b-form-select v-model="parametros.idCorredor" :options="opcoesCorredor" class="custom-input" />
                </b-form-group>
              </div>
            </transition>

            <transition name="fade">
              <div v-if="tipoSelecionado === 'OCORRENCIAS' && filtroOcorrencia === 'SALA'" class="mt-3">
                <b-form-group label="Selecione a Sala" label-class="font-weight-bold">
                  <model-list-select :list="opcoesSala"
                                     v-model="parametros.idSala"
                                     option-value="value"
                                     option-text="text"
                                     placeholder="Pesquise a sala...">
                  </model-list-select>
                </b-form-group>
              </div>
            </transition>
            
          </b-col>
          
          <b-col md="6" class="pl-md-4 d-flex flex-column justify-content-center align-items-center mt-4 mt-md-0">
            
            <div v-if="!tipoSelecionado" class="empty-state text-center text-muted">
               <b-icon icon="inbox" font-scale="4" class="mb-3 opacity-50"></b-icon>
               <h6>Nenhum relatório selecionado</h6>
               <p class="small">Selecione as opções ao lado para visualizar a exportação.</p>
            </div>

            <div v-else class="export-area w-100 text-center">
              <h5 class="section-title mb-3">Exportação</h5>
              <p class="text-muted mb-4 small">O seu relatório está pronto. Como deseja baixá-lo?</p>
              
              <div class="d-flex justify-content-center">
                <b-button size="sm" class="mr-3 action-btn" @click="baixarRelatorio('EXCEL')" :disabled="!isValido">
                  <b-icon icon="file-earmark-spreadsheet" class="mr-2"></b-icon> Excel
                </b-button>
                <b-button size="sm" class="action-btn" @click="baixarRelatorio('PDF')" :disabled="!isValido">
                  <b-icon icon="file-earmark-text" class="mr-2"></b-icon> PDF
                </b-button>
              </div>
            </div>

          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { RelatorioService } from '../../services/RelatorioService';
import ParametroService from '../../services/ParametroService';
import BarraNavegacao from '../../components/BarraNavegacao.vue';
import { ModelListSelect } from 'vue-search-select';

export default {
  name: 'GeradorRelatorios',
  components: {
    BarraNavegacao,
    ModelListSelect
  },
  created() {
    this.carregarParametros();
    this.carregarBlocos();
    this.carregarCorredores();
    this.carregarSalas();
  },
  data() {
    return {
      tipoSelecionado: null,
      tiposRelatorio: [
        { value: 'SOLICITACOES', text: 'Demandas (Solicitações)' },
        { value: 'CHECKLIST_PERIODO', text: 'Inventários/Checklists do Período' },
        { value: 'TOP_DEFEITOS', text: 'Itens com Defeito' },
        { value: 'PROGRESSO', text: 'Progresso de Inventários/Checklists' },
        { value: 'OCORRENCIAS', text: 'Ocorrências' }
      ],
      filtroOcorrencia: 'GERAL',
      opcoesFiltroOcorrencia: [
        { value: 'GERAL', text: 'Geral (Todas)' },
        { value: 'BLOCO', text: 'Por Bloco' },
        { value: 'CORREDOR', text: 'Por Corredor' },
        { value: 'SALA', text: 'Por Sala' }
      ],
      opcoesModulo: [
        { value: 'INVENTARIO', text: 'Inventário' },
        { value: 'CHECKLIST', text: 'Checklist' }
      ],
      opcoesBloco: [
        { value: null, text: 'Selecione um bloco...', disabled: true }
      ],
      opcoesCorredor: [
        { value: null, text: 'Selecione um corredor...', disabled: true }
      ],
      opcoesSala: [],
      parametros: {
        periodoLetivo: '',
        modulo: 'INVENTARIO',
        idBloco: null,
        idCorredor: null,
        idSala: null
      }
    };
  },
  computed: {
    isValido() {
      if (['CHECKLIST_PERIODO', 'TOP_DEFEITOS', 'PROGRESSO'].includes(this.tipoSelecionado)) {
        return this.parametros.periodoLetivo && this.parametros.modulo;
      }
      if (this.tipoSelecionado === 'OCORRENCIAS') {
        if (this.filtroOcorrencia === 'GERAL') return true;
        if (this.filtroOcorrencia === 'BLOCO') return this.parametros.idBloco !== null;
        if (this.filtroOcorrencia === 'CORREDOR') return this.parametros.idCorredor !== null;
        if (this.filtroOcorrencia === 'SALA') return this.parametros.idSala !== null;
        return false;
      }
      if (this.tipoSelecionado === 'SOLICITACOES') {
        return !!this.parametros.periodoLetivo;
      }
      return false;
    }
  },
  methods: {
    carregarParametros() {
      ParametroService.listarTodos().then(response => {
        const parametroPeriodo = response.data.find(p => p.identificador === 'PERIODO_LETIVO');
        if (parametroPeriodo) {
          this.parametros.periodoLetivo = parametroPeriodo.valor;
        }
      });
    },
    carregarBlocos() {
      this.$http.get("/bloco").then(res => {
        const blocos = res.data.filter(b => b.status === 'A');
        blocos.forEach(b => {
          this.opcoesBloco.push({ value: b.idBloco, text: b.descricao });
        });
      });
    },
    carregarCorredores() {
      this.$http.get("/corredores").then(res => {
        const corredores = res.data.filter(c => c.status === 'A');
        corredores.forEach(c => {
          this.opcoesCorredor.push({ value: c.idCorredor, text: c.descricao });
        });
      });
    },
    carregarSalas() {
      this.$http.get("/sala").then(res => {
        const salas = res.data.filter(s => s.status === 'A' && (!s.descricao || !s.descricao.toUpperCase().includes('CORREDOR')));
        salas.forEach(s => {
          this.opcoesSala.push({ value: s.idSala, text: s.descricaoCompleta || s.descricao });
        });
      });
    },
    baixarRelatorio(formato) {
      if (!this.isValido) return;

      this.$loading(true);

      let tipoParaExportar = this.tipoSelecionado;
      if (this.tipoSelecionado === 'OCORRENCIAS') {
        if (this.filtroOcorrencia === 'GERAL') tipoParaExportar = 'OCORRENCIAS_GERAIS';
        else if (this.filtroOcorrencia === 'BLOCO') tipoParaExportar = 'OCORRENCIAS_BLOCO';
        else if (this.filtroOcorrencia === 'CORREDOR') tipoParaExportar = 'OCORRENCIAS_CORREDOR';
        else if (this.filtroOcorrencia === 'SALA') tipoParaExportar = 'OCORRENCIAS_SALA';
      }

      RelatorioService.exportarRelatorio(tipoParaExportar, formato, this.parametros)
        .then(response => {
          this.$loading(false);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const extension = formato === 'EXCEL' ? 'xlsx' : 'pdf';
          
          let nomeArquivo = 'Relatorio';
          if (tipoParaExportar === 'CHECKLIST_PERIODO') {
              nomeArquivo = `Relatorio_${this.parametros.modulo}_${this.parametros.periodoLetivo}`;
          } else if (tipoParaExportar === 'OCORRENCIAS_BLOCO') {
              const blocoSelecionado = this.opcoesBloco.find(b => b.value === this.parametros.idBloco);
              let blocoNome = blocoSelecionado ? blocoSelecionado.text : this.parametros.idBloco;
              nomeArquivo = `Relatorio_Ocorrencias_${blocoNome.toString().replace(/\s+/g, '_')}`;
          } else if (tipoParaExportar === 'OCORRENCIAS_CORREDOR') {
              const corredorSelecionado = this.opcoesCorredor.find(c => c.value === this.parametros.idCorredor);
              let corredorNome = corredorSelecionado ? corredorSelecionado.text : this.parametros.idCorredor;
              nomeArquivo = `Relatorio_Ocorrencias_Corredor_${corredorNome.toString().replace(/\s+/g, '_')}`;
          } else if (tipoParaExportar === 'OCORRENCIAS_SALA') {
              const salaSelecionada = this.opcoesSala.find(s => s.value === this.parametros.idSala);
              let salaNome = salaSelecionada ? salaSelecionada.text : this.parametros.idSala;
              nomeArquivo = `Relatorio_Ocorrencias_Sala_${salaNome.toString().replace(/\s+/g, '_')}`;
          } else if (tipoParaExportar === 'SOLICITACOES') {
              nomeArquivo = `Relatorio_Demandas_${this.parametros.periodoLetivo}`;
          } else if (tipoParaExportar === 'TOP_DEFEITOS') {
              nomeArquivo = `Relatorio_TopDefeitos_${this.parametros.modulo}_${this.parametros.periodoLetivo}`;
          } else if (tipoParaExportar === 'PROGRESSO') {
              nomeArquivo = `Relatorio_Progresso_${this.parametros.modulo}_${this.parametros.periodoLetivo}`;
          } else if (tipoParaExportar === 'OCORRENCIAS_GERAIS') {
              nomeArquivo = `Relatorio_Ocorrencias_Gerais`;
          }
          
          link.setAttribute('download', `${nomeArquivo}.${extension}`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(() => {
          this.$loading(false);
          this.$alert('Erro ao gerar relatório.', 'Erro', 'error');
        });
    }
  }
};
</script>

<style scoped>
.report-wrapper {
  margin-bottom: 200px;
}
.page-title {
  font-weight: 700;
  color: #2c3e50;
  letter-spacing: -0.5px;
}
.page-subtitle {
  font-size: 0.95rem;
}
.page-icon-wrapper {
  background-color: #e8ecf8;
  padding: 15px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modern-card {
  border: none;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.04);
  overflow: visible !important;
}
.section-title {
  color: #344767;
  font-weight: 700;
  font-size: 1.1rem;
}
.custom-input {
  border-radius: 8px;
  border: 1px solid #dee2e6;
  height: calc(2.25rem + 5px);
  box-shadow: none;
}
.custom-input:focus {
  border-color: #303f9f;
  box-shadow: 0 0 0 0.2rem rgba(48, 63, 159, 0.15);
}
.action-btn {
  background-color: #303f9f;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 20px;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;
}
.action-btn:hover:not(:disabled) {
  background-color: #283593;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(48, 63, 159, 0.3);
}
.action-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.empty-state {
  padding: 40px 20px;
}
.opacity-50 {
  opacity: 0.5;
}
@media (min-width: 768px) {
  .border-right-custom {
    border-right: 1px solid #f0f2f5;
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
